<script lang="ts">
    import { Datatable } from 'svelte-simple-datatables'
    import { Progress } from 'sveltestrap'
    import { supportData } from '../../../Data/Miscellaneous/SupportTicket'
    const settings = {
      labels: {
        search: 'We can search here...',
      },
      pagination: true,
      scrollY: true,
      scrollX: true,
      rowsPerPage: 10,
      sortable: true,
    }
    let rows
</script>
  
<div class="table-responsive">
    <Datatable {settings} data={supportData} bind:dataRows={rows}>
    <thead>
        <tr>
            <th data-key="image">{'Image'}</th>
            <th data-key="position">{'Position'}</th>
            <th data-key="salary">{'Salary'}</th>
            <th data-key="office">{'Office'}</th>
            <th data-key="skill">{'Skill'}</th>
            <th data-key="ticket">{'Ticket No'}</th>
            <th data-key="e-mail">{'E-mail'}</th>
        </tr>
    </thead>
    <tbody class="ecommerce-widget">
        {#if rows}
            {#each $rows as row}
                <tr class="support-ticket">
                    <td>
                        {@html row.image}
                    </td>
                    <td>{row.position}</td>
                    <td>{row.salary}</td>
                    <td>{row.office}</td>
                    <td>
                        <Progress
                        value={80 * Math.random()}
                        color={row.skill}
                        class="support-kit" />
                    </td>
                    <td>{row.extn}</td>
                    <td>{row.email}</td>
                </tr>
            {/each}
        {/if}
    </tbody>
    </Datatable>
</div>
  